<template>
	<div class="add-user">
		<form @submit.prevent="register">
			<h2>Utenti iscritti</h2>

			<div class="users">
				<Member class="user" v-for="user in users" :key="user.id" :user="user" @delete="removeUser" @membership="user.membership = !user.membership"/>
			</div><!-- Lazzo culo! -->

			<h2>Registrazione utente</h2>

			<div class="field-grid">
				<div class="field">
					<input type="number" v-model.number="id" name="username" autocomplete="off" required/>
					<label>Codice id.</label>
				</div>

				<div class="field">
					<input type="text" v-model="username" name="username" autocomplete="off" readonly required/>
					<label>Username</label>
				</div>

				<div class="field">
					<input type="text" v-model="email" name="email" autocomplete="off" required/>
					<label>Email</label>
				</div>

				<div class="field">
					<input type="text" v-model="first_name" name="first_name" autocomplete="off" required/>
					<label>Nome</label>
				</div>

				<div class="field">
					<input type="text" v-model="last_name" name="last_name" autocomplete="off" required/>
					<label>Cognome</label>
				</div>

				<!-- Info -->

				<div class="field">
					<input type="date" v-model="start_date" name="birth_date" autocomplete="off"/>
					<label>Data di registrazione</label>
				</div>

				<div class="field">
					<input type="date" v-model="birth_date" name="birth_date" autocomplete="off" required/>
					<label>Data di nascita</label>
				</div>

				<div class="field">
					<input type="text" v-model="birth_place" name="birth_place" autocomplete="off" required/>
					<label>Luogo di nascita</label>
				</div>

				<div class="field">
					<input type="text" v-model="full_place" name="full_place" autocomplete="off" placeholder="Monza, 20900 (MB)" required/>
					<label>Luogo di residenza</label>
				</div>

				<div class="field">
					<input type="text" v-model="full_address" name="full_address" autocomplete="off" placeholder="Via Milano, 8" required/>
					<label>Indirizzo di residenza (via/piazza, n°)</label>
				</div>

				<div class="field">
					<input type="text" pattern="[A-Za-z0-9]{16}" v-model="personal_id" name="personal_id" autocomplete="off" required/>
					<label>Codice fiscale</label>
				</div>

				<div class="field">
					<input type="tel" pattern="[0-9]{10}" v-model="phone_number" name="phone_number" autocomplete="off" required/>
					<label>Cellulare</label>
				</div>

				<div class="field">
					<input type="text" v-model="password" name="password" readonly/>
					<label>Password <span style="cursor: pointer;" aria-roledescription="button" @click="password = generatePassword()">(clicca per rigenerare <span class="fas fa-redo"></span>)</span></label>
				</div>
			</div>

			<div class="field">
				<button>Registra</button>
			</div>
		</form>
	<!--	<img :src="require('@/assets/logo_eximus.svg')" style="margin-top:5px; width:200px;"/> -->
	</div>
</template>

<script>
import api from '@/api'
import pop, {notif} from '@/pop'

import Member from './Member'

export default {
	name: 'add-user',

	components: {
		Member
	},

	data() {

		return {
			// List of users
			users: [],

			// Id
			id: null,

			// Email
			email: '',

			// Password
			password: '',
			
			// Full name
			first_name: '',
			last_name: '',

			// Registration date
			start_date: this.$moment().format('YYYY-MM-DD'),

			// Personal data
			personal_id: 'AAAAAA00A00A000A',
			birth_date: '1800-01-01',
			birth_place: 'aaa',
			full_place: 'aaa, 00000 (AA)',
			full_address: 'aaa, 0',
			phone_number: '0000000000'
		}
	},

	computed: {		
		/**
		 * Decompose permanent address
		 */
		permanent() {
			
			const [, permanent_place, permanent_id = null, permanent_area = null] = /^([^,]+)(?:,\s*(\d+)(?:\s*\(([A-Z]+)\))?)?$/.exec(this.full_place.trim())
			const [, permanent_address, permanent_no = null] = /^([^,]+)(?:,\s*(\d+))?$/.exec(this.full_address.trim())

			return {
				permanent_place,
				permanent_id,
				permanent_area,
				permanent_address,
				permanent_no
			}
		},

		/**
		 *
		 */
		fullname() {

			return [this.first_name, this.last_name].join(' ').toLowerCase().replace(/[^\w]+/g, '_')
		},

		/**
		 * Username
		 */
		username() {

			return this.fullname + '#' + this.id
		}
	},

	methods: {
		/**
		 * 
		 */
		removeUser(userid) {
			
			console.log(this.users, userid)
			this.users = this.users.filter(({ id }) => id !== userid)
		},

		/**
		 * 
		 */
		async register() {

			try
			{
				await api.admin().register({
					id: this.id,
					username: this.username,
					email: this.email,
					password: this.password,
					first_name: this.first_name,
					last_name: this.last_name,
					start_date: this.start_date,
					personal_id: this.personal_id,
					birth_place: this.birth_place,
					birth_date: this.birth_date,
					...this.permanent,
					phone_number: this.phone_number
				})
				notif.done('Utente registrato!')
			}
			catch (err)
			{
				console.error(err.dev_msg || err)
				notif.error(err.display_msg || err)
			}
		},

		/**
		 * Generate new password
		 */
		generatePassword() {

			const len = 8
			const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_@#'

			let password = ''
			for (let i = 0, n = charset.length; i < len; ++i)
				password += charset.charAt(Math.floor(Math.random() * n))
			
			return password
		}
	},

	watch: {
		/**
		 * Update password
		 */
		fullname(val) {

			this.password = val
		}
	},

	created() {

		// Generate random password
		this.password = this.generatePassword()
	},

	async beforeRouteEnter(to, from, next) {

		const endpoint = api.admin()

		try
		{
			let users = await endpoint.getUsers()

			next((vm) => {

				vm.users = users
				vm.endpoint = endpoint
			})
		}
		catch (err)
		{
			console.error(err.dev_msg || err)
			notif.error(err.display_msg || err)
		}
	}
}
</script>

<style lang="stylus" scoped>
.users
	max-height 70vh

	overflow-y auto

	.user
		margin 0.5em auto

.field-grid
	display grid
	grid-gap 0.5em
	grid-template-columns repeat(2, 1fr)

.field
	margin 0.4em 0

	>input
		input()

		width 100%

		background-color darkish
		color light
		
		font-size 1.1em
		
		&:read-only
			color mix(darkish, lightish)
		&:focus
			outline-color primary
	
	>label
		display block

		margin-top 0.2em

		color primary

		font-family fontSans
		font-size 0.8em
	
	>button
		border none
		padding 0.4em 0.6em

		background-color primary
		color dark

		font-family fontSans
		font-size 1em
		font-weight bold

		text-transform uppercase

		cursor pointer
</style>